document.addEventListener("DOMContentLoaded", function ($ = jQuery) {
    var $ = require('jquery');
	$(document).on('click', '.footer-mobile-toggle', function(e) {

        e.preventDefault();
        
        $(this).next().slideToggle(400);
        
        $(this).toggleClass("open");
        
        if( $(this).attr('aria-expanded') =='true'){
            $(this).attr('aria-expanded','false');
        }

        else {
            $(this).attr('aria-expanded','true');
        }

	});

});


/* Newsletter sign up aria label */
let newsletterSubmitButton = document.querySelectorAll( '.btn.newsletter-btn' ), i;

for (i = 0; i < newsletterSubmitButton.length; ++i) {
	newsletterSubmitButton[i].setAttribute('aria-label', 'submit sign up for newsletter');
}